import { UrlParser } from './url-parser.utility';

export class UrlEncoder {
    /**
     * Encodes a URL so that it will properly open in the browser.
     * By default method: this assumes that the URL doesn't contain any fragments,
     * so all '#' characters are replaced with %23. The MRU++ service
     * does not return URLs with fragments.
     * This will not encode any characters not encoded by encodeURI, including '&' and '?'
     * By setting true to encodeComponents: this would be used to handle a more RFC compliant URL where the general structure of the url
     * is comprised of all and specifically including a query (?) and a fragment (#) where the '?' and '#' is used specifically for its respective sole
     * purpose. If a hash or questionmark exist at the end of a link but no fragments or parameters are provided respectively, such marks will be removed as a result.
     * @param url
     */
    public static encodeUrl(url: string, encodeComponents?: boolean): string {
        if (!url) {
            return '';
        }

        if (encodeComponents) {
            const a = UrlParser.getLocation(url);
            const encode = query => {
                if (!query) {
                    return '';
                }

                const querySplit = query.substring(1).split('&');
                let idx = 0;
                const newQueryString = querySplit.reduce((cum, cur) => {
                    const curSplit = cur.split('=');
                    const spacer = idx > 0 ? '&' : '';
                    idx++;
                    const parm = curSplit[0] && curSplit[1] ? curSplit[0] + '=' + encodeURIComponent(curSplit[1]) : curSplit[0] + (curSplit[1] === '' ? '=' : '');
                    cum = cum + spacer + parm;
                    return cum;
                }, '');
                return query[0] + newQueryString;
            };
            return encodeURI(a.protocol + '//' + a.host) + encodeURI(a.path) + encode(a.search) + encode(a.hash);
        } else {
            const encodedUrl = encodeURI(url); // Cannot use encodeURIComponent here since that will encode the '/' and ':' characters in the full URL.
            return encodedUrl.replace(/#/g, '%23');
        }
    }

    /**
     * Decodes a URL, including the '#' character.
     * @param url
     */
    public static decodeUrl(url: string): string {
        if (!url) {
            return '';
        }

        // If url is malformed decoding can throw error
        try {
            // Some of our services (MRU++ v2) encode characters ('&') that cannot be decoded with decodeURI, so we use
            // decodeURIComponent here to fully decode the url.
            return decodeURIComponent(url);
        } catch (err) {
            return '';
        }
    }
}
